import React, { useEffect } from "react";
import HeaderTransprent from "../../components/HeaderTransprent";
import Footer from "../../components/Footer";
import { Helmet } from "react-helmet";
import ContactForm from "../../ui/ContactForm";
import { GoMail } from "react-icons/go";
import { TbBuilding } from "react-icons/tb";

const ContactUs = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Happiest Workplaces | Connect with Our Team</title>
        <meta name="description" content="Discover the happiest workplaces! Connect with our team and learn about our positive work culture, collaborative environment, and employee satisfaction. Join us today!" />
        <link rel="canonical" href="https://happiestworkplaces.in/#/contact-us" />
      </Helmet>

      <div className="">
        <HeaderTransprent />
        <section className="bg-[#2196F3]/10 w-full h-auto bg-cover bg-no-repeat bg-right" style={{ backgroundImage: `url('/img/home/sub-header-bg.webp')`, }}>
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div data-aos="fade-up" className="space-y-2 text-[#3D405B] flex flex-col justify-center items-center">
                <h2 className="xl:text-6xl text-5xl leading-[3rem] xl:leading-[3.5rem] font-bold textcolor capitalize">Let’s Connect</h2>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white">
          <div className="flex flex-col justify-start w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 w-full">
              <div className="flex flex-col lg:flex-row">

                <div className="lg:w-2/5 space-y-4 flex flex-col justify-start mb-8 md:mb-0 pr-0 md:pr-16">
                  <div className="space-y-2 text-[#212121]">
                    <h2 className="text-3xl font-bold text-[#212121] capitalize">For Customer Support and Query, Get in touch with us.</h2>
                  </div>

                  <div className="space-y-0">
                    <div className="flex flex-row items-center gap-6 py-4 border-b">
                      <div className="flex justify-center items-center border border-[#BDBDBD] w-16 h-16 bg-white rounded-full textcolor">
                        <GoMail className="w-8 h-8" />
                      </div>
                      <div className=" mt-1 text-[#212121] flex-1">
                        <h1 className="text-xl font-semibold">Email</h1>
                        <p className="text-lg">connect@happyplus.in</p>
                      </div>
                    </div>

                    <div className="flex flex-row items-center gap-6 py-4 ">
                      <div className="flex justify-center items-center border border-[#BDBDBD] w-16 h-16 bg-white rounded-full textcolor">
                        <TbBuilding className="w-8 h-8" />
                      </div>
                      <div className=" mt-1 text-[#212121] flex-1">
                        <h1 className="text-xl font-semibold">Office Address:</h1>
                        <p className="text-lg">HappyPlus Consulting Pvt. Ltd. <br />Express Zone, Western Express Highway, Malad East, Mumbai - 400097</p>
                      </div>
                    </div>
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}


ContactUs.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};


export default ContactUs;
